<div class="main-content">
  <div class="catalogue">
    <div class="container mainContainer">
      <h1>Catalogue</h1>
    </div>

    <div class="catalogue-wrap">
      <div class="container">
        <form action="" class="row">
          <div class="col-md-7">
            <div class="row">
              <!-- Category Dropdown -->
              <div class="col-md-5 mb-3 mb-md-0 arrow">
                <select class="cst-form-control bg-white" name="category"
                  (change)="getCatalogueList('new')"
                  [(ngModel)]="categoryId">
                  <option value="" disabled selected>Select Category</option>
                  <option *ngFor="let category of categoryList"
                    [value]="category?.guidId">
                    {{ category?.categoryName }}
                  </option>
                </select>
              </div>

              <!-- Language Dropdown -->
              <div class="col-md-5 mb-3 mb-md-0 arrow">
                <select class="cst-form-control bg-white" name="language"
                  (change)="getCatalogueList('new')"
                  [(ngModel)]="languageId">
                  <option value="" disabled selected>Select Language</option>
                  <option *ngFor="let language of languageList"
                    [value]="language?.languageGuidId">
                    {{ language?.languageName }}
                  </option>
                </select>
              </div>

              <!-- Mobile Search Bar -->
              <div class="rightContainer" *ngIf="utils.screenSizeObj.width < 768">
                <div class="searchBar">
                  <img width="21" height="21" class="searchIcon" loading="lazy"
                    [src]="environment?.blobUrl+'/assets/icons/search.svg'" alt="Search | Luminous">
                  <input type="text" placeholder="Search for a catalogue" aria-label="Number"
                    matInput [formControl]="myControl" [matAutocomplete]="auto"
                    (keypress)="onEnter($event)"
                    (click)="getRecentlySearched(myControl.value)"
                    (focus)="getRecentlySearched(myControl.value)">
                  <mat-autocomplete #auto="matAutocomplete">
                    <mat-option *ngFor="let option of searchedcatalogue" [value]="option?.searchedText"
                      (click)="onSearchClick()">
                      <img loading="lazy" width="12" height="12"
                        [src]="environment?.blobUrl+'/assets/icons/clock.webp'"
                        alt="Clock Icon | Luminous">
                      {{ option?.searchedText }}
                    </mat-option>
                  </mat-autocomplete>
                  <img width="12" height="12" *ngIf="myControl.value" class="closeIcon" loading="lazy"
                    [src]="environment?.blobUrl+'/assets/icons/close.svg'"
                    alt="Cancel | Luminous" (click)="clearSearch()">
                </div>
              </div>

              <!-- Reset Filters Button -->
              <div class="col-md-2 text-center text-md-start">
                <input *ngIf="categoryId === '' && languageId === '' && !myControl.value"
                  type="button" value="Reset Filters" class="greyBtn">
                <input *ngIf="categoryId !== '' || languageId !== '' || myControl.value"
                  type="button" value="Reset Filters" (click)="resetFilter()" class="primaryBtn">
              </div>
            </div>
          </div>

          <!-- Desktop Search Bar -->
          <div class="col-md-5 d-flex justify-content-end" *ngIf="utils.screenSizeObj.width > 768">
            <div class="rightContainer">
              <div class="searchBar">
                <img width="21" height="21" class="searchIcon" loading="lazy"
                  [src]="environment?.blobUrl+'/assets/icons/search.svg'" alt="Search | Luminous">
                <input type="text" placeholder="Search for a catalogue" aria-label="Number"
                  matInput [formControl]="myControl" [matAutocomplete]="auto"
                  (keypress)="onEnter($event)"
                  (click)="getRecentlySearched(myControl.value)"
                  (focus)="getRecentlySearched(myControl.value)">
                <mat-autocomplete #auto="matAutocomplete">
                  <mat-option *ngFor="let option of searchedcatalogue" [value]="option?.searchedText"
                    (click)="onSearchClick()">
                    <img loading="lazy" width="12" height="12"
                      [src]="environment?.blobUrl+'/assets/icons/clock.webp'"
                      alt="Clock Icon | Luminous">
                    {{ option?.searchedText }}
                  </mat-option>
                </mat-autocomplete>
                <img width="12" height="12" *ngIf="myControl.value" class="closeIcon" loading="lazy"
                  [src]="environment?.blobUrl+'/assets/icons/close.svg'"
                  alt="Cancel | Luminous" (click)="clearSearch()">
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>

    <div class="container">
      <!-- Catalogue List -->
      <div class="row" *ngIf="filteredCatalogueList?.length">
        <div class="col-md-3" *ngFor="let catalogue of filteredCatalogueList">
          <div class="catalogue-box" (click)="downloadCatalogue(catalogue?.catalogueUrl)">
            <img loading="lazy" [src]="catalogue?.imageUrl" [alt]="catalogue?.imageAltTag">
            <h4>{{ catalogue?.catalogueName }}</h4>
            <h4 class="lan">{{ catalogue?.languageName }}</h4>
          </div>
        </div>

        <!-- Load More Button -->
        <div class="text-center catalogue-btn">
          <a *ngIf="catalogueList.length < totalCount && !myControl.value"
            (click)="getCatalogueList('more')" class="grey-btn arrow text-start">
            Load More
          </a>
        </div>
      </div>

      <!-- No Search Results -->
      <div class="row" *ngIf="!filteredCatalogueList?.length && myControl.value">
        <h3>No matching catalogues found. Try a different search term.</h3>
      </div>

      <!-- No Catalogues Found -->
      <div class="row" *ngIf="!catalogueList?.length">
        <h3>No Catalogue Found</h3>
      </div>
    </div>
  </div>
</div>
